// extracted by mini-css-extract-plugin
module.exports = {"customDragger":"UploadFilesField_customDragger__3dOxF","title":"UploadFilesField_title__38NTC","description":"UploadFilesField_description__3lb0G"};